import * as actionTypes from './actionTypes'

export function updateDeclarationSectionField(field, payload) {
  setTimeout(()=>{
    document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
  },50)
  return {
    type: actionTypes.UPDATE_DECLARATION_SECTION_FIELD,
    payload,
    field
  }
}

export function saveDeclarationSectionFieldObject( payloadcc) {
  return {
    type: actionTypes.SAVE_DECLARATION_SECTION_FIELD,
    payloadcc
  }
}
